module.exports = __webpack_public_path__ + "img/export.ab739713.svg";